import registerCard from '../../../common/cards/index';
import presentationalComponent from './Card';
import containerComponent from './CardContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { ELEMENT_FEATURES } from '../feature/elementFeatureConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerCard({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.REACTION],
        features: [ELEMENT_FEATURES.DOCUMENT, ELEMENT_FEATURES.DESCRIPTION, ELEMENT_FEATURES.TRANSPARENT],
        selectedTools: [
            { ...TOOLBAR_TOOLS.COLOR, name: 'Card color' },
            TOOLBAR_TOOLS.REACTION,
            ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
        ],
        editingTools: TOOL_SETS.TEXT_EDITING_INLINE_AND_BLOCK,
        tooltip: isApple ? '⌃⌘N' : 'Ctrl+Alt+N',
    });
